<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/avignonesi')">Avignonesi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active two-line"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri')">Azienda
                        Agricola Casanova di Neri
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-salvioni')">Azienda Salvioni
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/castiglione-del-bosco')">Castiglione del Bosco
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/conti-constani')">Conti Constani
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-le-pupille')">Fattoria Le Pupille
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-poggio-di-sotto')">Fattoria Poggio di
                        Sotto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fontodi')">Fontodi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/frescobaldi')">Frescobaldi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/gianfranco-soldera')">Gianfranco Soldera
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/isole-e-olena')">Isole e Olena
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/marchesi-antinori')">Marchesi Antinori
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/podere-poggio-scalette')">Podere Poggio
                        Scalette
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/poderi-boscarelli')">Poderi Boscarelli
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/rocca-di-frassinello')">Rocca di Frassinello
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-dell-ornellaia')">Tenuta dell’Ornellaia
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-di-trinoro')">Tenuta di Trinoro
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-san-guido')">Tenuta San Guido
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Azienda Agricola Casanova di Neri</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        La prima esperienza enologica italiana della maggior parte delle persone è probabilmente con un Chianti. Mentre ti imbarchi nel tuo
                        Viaggio nel vino italiano, ce ne sono alcuni buoni con cui far scoppiare la tua proverbiale ciliegia... viaggi verso il basso
                        la memoria ci porta agli aromatici Massetos della Tenuta dell'Ornellaia o al complesso Gianfranco
                        I Soldera Case Bass sono buoni punti di partenza. Ma in qualche modo l'Azienda Agricola Casanova di Neri aveva
                        scivolato attraverso la nostra rete. Finora.
                    </div>

                    <div class="howto-title2">Un'altra magica Montalcino</div>
                    <div class="howto-text">
                        Azienda vinicola a conduzione familiare fondata nel 1971, l'Azienda Agricola Casanova di Neri si trova sul
                        periferia di Montalcino. A partire da 12 ettari, l'attuale proprietario Giovanni Neri (nipote del
                        originale Giovanni) ha ampliato la tenuta durante l'ultimo 20° secolo e oggi la tenuta
                        si estende su 63 ettari, suddivisi in cinque parcelle: Pietradonice, Le Cetine, Cerretalto, Fiesole
                        e Podernuovo (la più alta delle parcelle, posta ad un'altitudine di 450 metri sul livello del mare). UN
                        grazioso casale e nuova cantina all'avanguardia completano il quadro.
                    </div>

                    <div class="howto-title2">Tre è il numero magico</div>
                    <div class="howto-text">
                        Come per la maggior parte dei vini italiani, il prodotto dell'Azienda Agricola Casanova di Neri è un'accurata espressione del terroir. Pienamente aromatizzati, i tre Brunello di Neri sono l'apice della tenuta.
                        Lungo affinamento in botti di rovere di Slavonia (il Di Montalcino è invecchiato 45 mesi, il Di Montalcino
                        Tenuta Nuova tra 27-36 mesi e Di Montalcino Cerretalto per 24-30 mesi) significa lungo
                        invecchiando una volta in bottiglia, quindi per ottenere i migliori risultati di consumo, dovrai essere paziente prima del vino
                        si apre completamente.
                    </div>

                    <div class="howto-title2">Un vino italiano in America</div>
                    <div class="howto-text">
                        Per i migliori risultati di investimento, la nostra attenzione è rivolta al favoloso Di Montalcino
                        Tenuta Nuova, vincitrice del trofeo Wine of the Year da Wine Spectator nel 2006. L'annata 2010
                        ha ricevuto ben 99 punti da James Suckling, mentre la stessa annata ha ottenuto un perfetto 100 da
                        Roberto Parker. Il punteggio perfetto di Parker aveva portato a un enorme aumento di interesse negli Stati Uniti, e da allora
                        Q2 2019 è stato più facile (anche se molto più costoso) trovare una bottiglia della leggendaria annata
                        negli Stati Uniti che in Europa e persino in Italia. Un prezzo lento ma costante del 25% in 24 mesi tra
                        Il 2017 e il 2019 rendono questa bottiglia una delle preferite dai collezionisti.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Azienda Agricola Casanova di Neri</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Das erste italienische Weinerlebnis erleben die meisten Menschen wahrscheinlich mit einem Chianti. Während Sie sich auf den Weg machen
                        Italienische Weinreise, es gibt einige gute Weine, mit denen Sie Ihre sprichwörtliche Kirsche platzen lassen können ... Ausflüge nach unten
                        Erinnerungen führen uns zu den aromatischen Massetos von Tenuta dell’Ornellaia oder dem komplexen Gianfranco
                        Soldera Case-Bässe sind ein guter Ausgangspunkt. Aber irgendwie hatte es die Azienda Agricola Casanova di Neri geschafft
                        durch unser Netz gerutscht. Bis jetzt.
                    </div>

                    <div class="howto-title2">Ein weiteres magisches Montalcino</div>
                    <div class="howto-text">
                        Die Azienda Agricola Casanova di Neri ist ein familiengeführtes Weingut, das 1971 gegründet wurde
                        Stadtrand von Montalcino. Der derzeitige Besitzer Giovanni Neri (Enkel des.) begann mit 12 Hektar
                        (ursprünglich Giovanni) erweiterte das Anwesen im späten 20. Jahrhundert und ist heute das Anwesen
                        ist 63 Hektar groß und in fünf Parzellen unterteilt: Pietradonice, Le Cetine, Cerretalto, Fiesole
                        und Podernuovo (das höchste der Parzellen, auf einer Höhe von 450 Metern über dem Meeresspiegel gelegen). A
                        Ein hübsches Bauernhaus und ein neues, hochmodernes Weingut runden das Bild ab.
                    </div>

                    <div class="howto-title2">Drei ist die magische Zahl</div>
                    <div class="howto-text">
                        Wie die meisten italienischen Weine ist das Produkt der Azienda Agricola Casanova di Neri ein getreuer Ausdruck des Terroirs. Die drei Brunellos von di Neri sind voller Geschmack und der Höhepunkt des Weinguts.
                        Lange Reifung in slawonischen Eichenfässern (der Di Montalcino reift 45 Monate, der Di Montalcino
                        Tenuta Nuova zwischen 27 und 36 Monaten und der Di Montalcino Cerretalto zwischen 24 und 30 Monaten) bedeutet lang
                        Der Wein reift einmal in der Flasche. Um optimale Trinkergebnisse zu erzielen, müssen Sie vor dem Wein geduldig sein
                        öffnet sich vollständig.
                    </div>

                    <div class="howto-title2">Ein italienischer Wein in Amerika</div>
                    <div class="howto-text">
                        Um die besten Anlageergebnisse zu erzielen, richtet sich unsere Aufmerksamkeit auf das fabelhafte Di Montalcino
                        Tenuta Nuova, Gewinnerin der Trophäe „Wein des Jahres“ von Wine Spectator im Jahr 2006. Der Jahrgang 2010
                        erhielt von James Suckling satte 99 Punkte, während der gleiche Jahrgang perfekte 100 Punkte erzielte
                        Robert Parker. Parkers perfektes Ergebnis hatte in den USA zu einem enormen Anstieg des Interesses geführt
                        Im zweiten Quartal 2019 war es einfacher (wenn auch weitaus teurer), eine Flasche des legendären Jahrgangs zu finden
                        in den USA als in Europa und sogar in Italien. Ein langsamer, aber stetiger Preis von 25 % in 24 Monaten dazwischen
                        2017 und 2019 machen diese Flasche zu einem Sammlerfavoriten.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Azienda Agricola Casanova di Neri</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        La première expérience viticole italienne de la plupart des gens est probablement avec un Chianti. Alors que vous vous lancez dans votre
                        Voyage dans le vin italien, il y en a de bons pour faire éclater votre cerise proverbiale avec... des voyages vers le bas
                        la voie de la mémoire nous emmène aux Massetos aromatiques de Tenuta dell'Ornellaia ou au complexe Gianfranco
                        Les basses Soldera Case sont de bons points de départ. Mais d'une manière ou d'une autre, Azienda Agricola Casanova di Neri avait
                        glissé à travers notre filet. Jusqu'ici.
                    </div>

                    <div class="howto-title2">Un autre Montalcino magique</div>
                    <div class="howto-text">
                        Exploitation viticole familiale fondée en 1971, Azienda Agricola Casanova di Neri est située sur la
                        périphérie de Montalcino. A partir de 12 hectares, l'actuel propriétaire Giovanni Neri (petit-fils du
                        Giovanni d'origine) a agrandi le domaine au cours du dernier 20e siècle et aujourd'hui le domaine
                        s'étend sur 63 hectares, divisés en cinq parcelles : Pietradonice, Le Cetine, Cerretalto, Fiesole
                        et Podernuovo (la plus haute des parcelles, située à une altitude de 450 mètres au-dessus du niveau de la mer). UN
                        une jolie ferme et une nouvelle cave à la pointe de la technologie complètent le tableau.
                    </div>

                    <div class="howto-title2">Trois est le nombre magique</div>
                    <div class="howto-text">
                        Comme pour la plupart des vins italiens, le produit de l'Azienda Agricola Casanova di Neri est une expression fidèle du terroir. Entièrement aromatisés, les trois Brunello de di Neri sont l'apogée du domaine.
                        Long vieillissement en fûts de chêne de Slavonie (le Di Montalcino est vieilli pendant 45 mois, le Di Montalcino
                        Tenuta Nuova entre 27-36 mois et le Di Montalcino Cerretalto pendant 24-30 mois) signifie long
                        vieillir une fois en bouteille, donc pour de meilleurs résultats de consommation, vous devrez être patient avant le vin
                        s'ouvre entièrement.
                    </div>

                    <div class="howto-title2">Un vin italien en Amérique</div>
                    <div class="howto-text">
                        Pour les meilleurs résultats d'investissement, notre attention est dirigée vers le fabuleux Di Montalcino
                        Tenuta Nuova, lauréate du trophée Vin de l'année par Wine Spectator en 2006. Le millésime 2010
                        a reçu un énorme 99 points par James Suckling tandis que le même millésime a marqué un 100 parfait de
                        Robert Parker. Le score parfait de Parker avait suscité un énorme regain d'intérêt aux États-Unis, et à partir de
                        Au deuxième trimestre 2019, il était plus facile (bien que beaucoup plus cher) de trouver une bouteille du millésime légendaire
                        aux États-Unis qu'en Europe et même en Italie. Un prix lent mais régulier de 25% en 24 mois entre
                        2017 et 2019 font de cette bouteille un favori des collectionneurs.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Azienda Agricola Casanova di Neri</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Most people’s first Italian wine experience is probably with a Chianti. As you embark on your
                        Italian wine journey, there are some good ones to pop your proverbial cherry with... trips down
                        memory lane take us to aromatic Massetos made by Tenuta dell’Ornellaia or complex Gianfranco
                        Soldera Case Basses are good places to start. But somehow Azienda Agricola Casanova di Neri had
                        slipped through our net. Until now.
                    </div>

                    <div class="howto-title2">Another magical Montalcino</div>
                    <div class="howto-text">
                        A family-run winery founded in 1971, Azienda Agricola Casanova di Neri is located on the
                        outskirts of Montalcino. Starting with 12-hectares, current owner Giovanni Neri (grandson of the
                        original Giovanni) expanded the estate during the latter 20th century and today the estate
                        stands at 63-hectares, divided into five parcels: Pietradonice, Le Cetine, Cerretalto, Fiesole
                        and Podernuovo (the highest of the parcels, set at an altitude of 450 metres above sea level). A
                        pretty farmhouse and new state of the art winery completes the picture.
                    </div>

                    <div class="howto-title2">Three is the magic number</div>
                    <div class="howto-text">
                        As with most Italian wines, Azienda Agricola Casanova di Neri’s product is an accurate expression of the terroir. Fully flavoured, di Neri’s three Brunellos are the estate's zenith.
                        Long ageing in Slavonian oak botti (the Di Montalcino is aged for 45 months, the Di Montalcino
                        Tenuta Nuova between 27-36 months and the Di Montalcino Cerretalto for 24-30 months) means long
                        ageing once in bottle, so for best drinking results, you will need to be patient before the wine
                        fully opens up.
                    </div>

                    <div class="howto-title2">An Italian wine in America</div>
                    <div class="howto-text">
                        For the best investment results, our attention is directed towards the fabulous Di Montalcino
                        Tenuta Nuova, winner of the Wine of the Year trophy by Wine Spectator in 2006. The 2010 vintage
                        was given a massive 99 points by James Suckling while the same vintage scored a perfect 100 from
                        Robert Parker. Parker’s perfect score had led to a huge surge in interest in the US, and as of
                        Q2 2019 it was easier (although far more expensive) to find a bottle of the legendary vintage
                        stateside than in Europe and even Italy. A slow but steady price of 25% in 24 months between
                        2017 and 2019 makes this bottle a collectors favourite.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AziendaAgricolaCasanovaNeri",
    head: {
        title: 'Azienda Agricola Casanova di Neri | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional wines from Azienda Agricola Casanova di Neri, a premium wine producer in Tuscany, renowned for their traditional winemaking techniques and innovative approach. Experience the unique flavors and aromas of Tuscany in every glass.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {
                report: 'Azienda Agricola Casanova di Neri',
                src: '/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri'
            },
            items: [
                {report: 'Avignonesi', src: '/wine-guide/italy/tuscany/аvignonesi'},
                {
                    report: 'Azienda Agricola Casanova di Neri',
                    src: '/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri'
                },
                {report: 'Azienda Salvioni', src: '/wine-guide/italy/tuscany/azienda-salvioni'},
                {report: 'Castiglione del Bosco', src: '/wine-guide/italy/tuscany/castiglione-del-bosco'},
                {report: 'Conti Constani', src: '/wine-guide/italy/tuscany/conti-constani'},
                {report: 'Fattoria Le Pupille', src: '/wine-guide/italy/tuscany/fattoria-le-pupille'},
                {report: 'Fattoria Poggio di Sotto', src: '/wine-guide/italy/tuscany/fattoria-poggio-di-sotto'},
                {report: 'Fontodi', src: '/wine-guide/italy/tuscany/fontodi'},
                {report: 'Frescobaldi', src: '/wine-guide/italy/tuscany/frescobaldi'},
                {report: 'Gianfranco Soldera', src: '/wine-guide/italy/tuscany/gianfranco-soldera'},
                {report: 'Isole e Olena', src: '/wine-guide/italy/tuscany/isole-e-olena'},
                {report: 'Marchesi Antinori', src: '/wine-guide/italy/tuscany/marchesi-antinori'},
                {report: 'Podere Poggio Scalette', src: '/wine-guide/italy/tuscany/podere-poggio-scalette'},
                {report: 'Poderi Boscarelli', src: '/wine-guide/italy/tuscany/poderi-boscarelli'},
                {report: 'Tenuta dell’Ornellaia', src: '/wine-guide/italy/tuscany/tenuta-dell-ornellaia'},
                {report: 'Tenuta di Trinoro', src: '/wine-guide/italy/tuscany/tenuta-di-trinoro'},
                {report: 'Tenuta San Guido', src: '/wine-guide/italy/tuscany/tenuta-san-guido'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}
.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
